import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const Rhombus = (props: NovaIconProps) => (
  <Icon
    {...props}
    component={() => (
      <svg
        width="1em"
        height="1em"
        focusable={false}
        viewBox="2 2 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 4.15319L6.07611 15.7311C6.05072 15.7607 6 15.8512 6 16C6 16.1488 6.05072 16.2393 6.07611 16.2689L16 27.8468L25.9239 16.2689C25.9493 16.2393 26 16.1488 26 16C26 15.8512 25.9493 15.7607 25.9239 15.7311L16 4.15319ZM4.5576 14.4295C3.81413 15.2969 3.81413 16.7031 4.5576 17.5705L14.6538 29.3495C15.3973 30.2168 16.6027 30.2168 17.3462 29.3495L27.4424 17.5705C28.1859 16.7031 28.1859 15.2969 27.4424 14.4295L17.3462 2.65053C16.6027 1.78316 15.3973 1.78316 14.6538 2.65053L4.5576 14.4295Z"
          fill="currentColor"
        />
      </svg>
    )}
  />
)

export default Rhombus
